import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const PaygradeApi = createApi({
  reducerPath: 'PaygradeApi',
  baseQuery,
  tagTypes: ['paygrade'],
  endpoints: builder => ({
    getPaygrade: builder.query<any, { search?: string } | void>({
      query: params => {
        const queryParams = new URLSearchParams();
        if (params?.search) queryParams.append('q', params.search);

        return `/payroll/paygrades?${queryParams.toString()}`;
      },
      providesTags: ['paygrade'],
    }),
    createPaygrade: builder.mutation<any, any>({
      query: newPaygrade => ({
        url: '/payroll/paygrades',
        method: 'POST',
        body: newPaygrade,
      }),
      invalidatesTags: ['paygrade'],
    }),
    updatePaygrade: builder.mutation<any, { id: string; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/payroll/paygrades/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['paygrade'],
    }),
    deletePaygrade: builder.mutation<void, number>({
      query: id => ({
        url: `/payroll/paygrades/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['paygrade'],
    }),
  }),
});

export const {
  useGetPaygradeQuery,
  useCreatePaygradeMutation,
  useUpdatePaygradeMutation,
  useDeletePaygradeMutation,
} = PaygradeApi;
